export const ADQUIRENTE_STYLES: Record<
  string,
  { code: string; bgColor: string; textColor: string }
> = {
  Transbank: { code: 'TB', bgColor: 'bg-red-100 dark:bg-red-900/20', textColor: 'text-red-600 dark:text-red-400' },
  Getnet: { code: 'GN', bgColor: 'bg-purple-100 dark:bg-purple-900/20', textColor: 'text-purple-600 dark:text-purple-400' },
  Santander: { code: 'ST', bgColor: 'bg-blue-100 dark:bg-blue-900/20', textColor: 'text-blue-600 dark:text-blue-400' },
  Itau: { code: 'IT', bgColor: 'bg-orange-100 dark:bg-orange-900/20', textColor: 'text-orange-600 dark:text-orange-400' },
};

export interface Cuota {
  id: string;
  cuotaNum: number;
  totalCuotas: number;
  fechaAbono: string;
  montoOriginal: number;
  diasAdelanto: number;
  comisionFlux: number;
  tye: number;
  recibiras: number;
}

export interface Venta {
  id: string;
  fechaVenta: string;
  adquirente: string;
  cuotaDisplay: string;
  abonoOriginal: number | null;
  comisionFlux: number | null;
  recibiras: number | null;
  cuotas: Cuota[];
}

export type SolicitudEstado =
  | 'revision'
  | 'aprobada'
  | 'desembolsada'
  | 'en_cobro'
  | 'cobrada'
  | 'abandonada'
  | 'cancelada'
  | 'abonada'
  | 'rechazada';

export interface Solicitud {
  id: string;
  fecha: string;
  hora: string;
  montoTotal: number | null;
  estado: SolicitudEstado;
}

export interface SolicitudDetalleCuota {
  cuotaLabel: string;
  fechaAbono: string;
  montoOriginal: number;
  diasAdelanto: number;
  comisionFlux: number;
  recibiras: number;
}

export interface SolicitudDetalleVenta {
  id: string;
  fechaVenta: string;
  adquirente: string;
  cuotaDisplay: string;
  abonoOriginal: number;
  comisionFlux: number;
  recibiras: number;
  cuotas: SolicitudDetalleCuota[];
}

export interface SolicitudDetalle {
  id: string;
  fecha: string;
  hora: string;
  estado: SolicitudEstado;
  motivoRechazo?: string;
  cancelableUntil?: string | null;
  subtotal: number;
  comisionTotal: number;
  tye?: number;
  totalTransferido: number;
  ventas: SolicitudDetalleVenta[];
}
